export const Minor = [
  { name: "A01 Alliance/Advocacy Organizations" },
  { name: "A02 Management & Technical Assistance" },
  { name: "A03 Professional Societies, Associations" },
  { name: "A05 Research Institutes and/or Public Policy Analysis" },
  { name: "A11 Single Organization Support" },
  { name: "A12 Fund Raising and/or Fund Distribution" },
  { name: "A19 Nonmonetary Support N.E.C." },
  { name: "A20 Arts, Cultural Organizations - Multipurpose" },
  { name: "A23 Cultural, Ethnic Awareness" },
  { name: "A24 Folk Arts" },
  { name: "A25 Arts Education/Schools" },
  { name: "A26 Arts Council/Agency" },
  { name: "A27 Community Celebrations" },
  { name: "A30 Media, Communications Organizations" },
  { name: "A31 Film, Video" },
  { name: "A32 Television" },
  { name: "A33 Printing, Publishing" },
  { name: "A34 Radio" },
  { name: "A40 Visual Arts Organizations" },
  { name: "A50 Museum & Museum Activities" },
  { name: "A51 Art Museums" },
  { name: "A52 Children's Museums" },
  { name: "A54 History Museums" },
  { name: "A56 Natural History, Natural Science Museums" },
  { name: "A57 Science & Technology Museum" },
  { name: "A60 Performing Arts" },
  { name: "A61 Performing Arts Centers" },
  { name: "A62 Dance" },
  { name: "A63 Ballet" },
  { name: "A65 Theater" },
  { name: "A68 Music" },
  { name: "A69 Symphony Orchestras" },
  { name: "A6A Opera" },
  { name: "A6B Singing Choral" },
  { name: "A6C Music Groups, Bands, Ensembles" },
  { name: "A6E Performing Arts Schools" },
  { name: "A70 Humanities Organizations" },
  { name: "A80 Historical Societies and Related Activities" },
  { name: "A82 Historical Societies & Historic Preservation" },
  { name: "A84 Commemorative Events" },
  { name: "A90 Arts Service Activities/Organizations" },
  { name: "A99 Other Art, Culture, Humanities Organizations/Services N.E.C." },
  { name: "B01 Alliance/Advocacy Organizations" },
  { name: "B02 Management & Technical Assistance" },
  { name: "B03 Professional Societies & Associations" },
  { name: "B05 Research Institutes and/or Public Policy Analysis" },
  { name: "B11 Single Organization Support" },
  { name: "B12 Fund Raising and/or Fund Distribution" },
  { name: "B19 Nonmonetary Support N.E.C." },
  { name: "B20 Elementary, Secondary Ed" },
  { name: "B21 Kindergarten, Nursery Schools, Preschool, Early Admissions" },
  { name: "B24 Primary/Elementary Schools" },
  { name: "B25 Secondary/High School" },
  {
    name:
      "B28 Specialized Education Institutions/Schools for Visually or Hearing Impaired, Learning Disabled"
  },
  { name: "B29 Charter Schools" },
  { name: "B30 Vocational Technical" },
  { name: "B40 Higher Education Institutions" },
  { name: "B41 Community/Junior College" },
  { name: "B42 Undergraduate College (4-year)" },
  { name: "B43 University or Technological" },
  { name: "B50 Graduate, Professional(Separate Entities)" },
  { name: "B60 Adult, Continuing Education" },
  { name: "B70 Libraries, Library Science" },
  { name: "B80 Student Services and Organizations" },
  { name: "B82 Scholarships, Student Financial Aid, Awards" },
  { name: "B83 Student Sororities, Fraternities" },
  { name: "B84 Alumni Associations" },
  { name: "B90 Educational Services and Schools - Other" },
  { name: "B92 Remedial Reading, Reading Encouragement" },
  { name: "B94 Parent Teacher Group" },
  { name: "B99 Education N.E.C." },
  { name: "C01 Alliance/Advocacy Organizations" },
  { name: "C02 Management & Technical Assistance" },
  { name: "C03 Professional Societies & Associations" },
  { name: "C05 Research Institutes and/or Public Policy Analysis" },
  { name: "C11 Single Organization Support" },
  { name: "C12 Fund Raising and/or Fund Distribution" },
  { name: "C19 Nonmonetary Support N.E.C." },
  { name: "C20 Pollution Abatement and Control Services" },
  { name: "C27 Recycling" },
  { name: "C30 Natural Resource Conservation and Protection" },
  { name: "C32 Water Resource, Wetlands Conservation and Management" },
  { name: "C34 Land Resources Conservation" },
  { name: "C35 Energy Resources Conservation and Development" },
  { name: "C36 Forest Conservation" },
  { name: "C40 Botanical, Horticultural, and Landscape Services" },
  { name: "C41 Botanical Gardens, Arboreta and Botanical Organizations" },
  { name: "C42 Garden Club, Horticultural Programs" },
  { name: "C50 Environmental Beautification" },
  { name: "C60 Environmental Education and Outdoor Survival Programs" },
  { name: "C99 Environmental Quality, Protection, and Beautification N.E.C." },
  { name: "D01 Alliance/Advocacy Organizations" },
  { name: "D02 Management & Technical Assistance" },
  { name: "D03 Professional Societies, Associations" },
  { name: "D05 Research Institutes and/or Public Policy Analysis" },
  { name: "D11 Single Organization Support" },
  { name: "D12 Fund Raising and/or Fund Distribution" },
  { name: "D19 Nonmonetary Support N.E.C." },
  {
    name:
      "D20 Animal Protection and Welfare (includes Humane Societies and SPCAs)"
  },
  { name: "D30 Wildlife Preservation/Protection" },
  { name: "D31 Protection of Endangered Species" },
  { name: "D32 Bird Sanctuary/Preserve" },
  { name: "D33 Fisheries" },
  { name: "D34 Wildlife Sanctuary/Refuge" },
  { name: "D40 Veterinary Services" },
  { name: "D50 Zoo, Zoological Society" },
  { name: "D60 Other Services" },
  { name: "D61 Animal Training, Behavior" },
  { name: "D99 Animal Related Activities N.E.C." },
  { name: "E01 Alliance/Advocacy Organizations" },
  { name: "E02 Management & Technical Assistance" },
  { name: "E03 Professional Societies & Associations" },
  { name: "E05 Research Institutes and/or Public Policy Analysis" },
  { name: "E11 Single Organization Support" },
  { name: "E12 Fund Raising and/or Fund Distribution" },
  { name: "E19 Nonmonetary Support N.E.C." },
  { name: "E20 Hospitals and Primary Medical Care Facilities" },
  { name: "E21 Community Health Systems" },
  { name: "E22 Hospital (General)" },
  { name: "E24 Hospital (Specialty)" },
  { name: "E30 Health Treatment Facilities (Primarily Outpatient)" },
  { name: "E31 Group Health Practice (Health Maintenance Organizations)" },
  { name: "E32 Ambulatory Health Center, Community Clinic" },
  { name: "E40 Reproductive Health Care Facilities and Allied Services" },
  { name: "E42 Family Planning Centers" },
  { name: "E50 Rehabilitative Medical Services" },
  { name: "E60 Health Support Services" },
  { name: "E61 Blood Supply Related" },
  { name: "E62 Ambulance/Emergency Transport" },
  { name: "E65 Organ and Tissue Bank" },
  { name: "E70 Public Health Program" },
  { name: "E80 Health (General and Financing)" },
  { name: "E86 Patient Services - Entertainment, Recreation" },
  { name: "E90 Nursing Services General (includes Candy Stripers)" },
  { name: "E91 Nursing, Convalescent (Geriatric and Nursing)" },
  { name: "E92 Home Health Care (includes Visiting Nurse Associations)" },
  { name: "E99 Health - General and Rehabilitative N.E.C." },
  { name: "F01 Alliance/Advocacy Organizations" },
  { name: "F02 Management & Technical Assistance" },
  { name: "F03 Professional Societies & Associations" },
  { name: "F05 Research Institutes and/or Public Policy Analysis" },
  { name: "F11 Single Organization Support" },
  { name: "F12 Fund Raising and/or Fund Distribution" },
  { name: "F19 Nonmonetary Support N.E.C." },
  {
    name:
      "F20 Alcohol, Drug and Substance Abuse, Dependency Prevention and Treatment"
  },
  { name: "F21 Alcohol, Drug Abuse (Prevention Only)" },
  { name: "F22 Alcohol, Drug Abuse (Treatment Only)" },
  { name: "F30 Mental Health Treatment" },
  { name: "F31 Psychiatric, Mental Health Hospital" },
  { name: "F32 Community Mental Health Center" },
  {
    name:
      "F33 Group Home, Residential Treatment Facility - Mental Health Related"
  },
  { name: "F40 Hot Line, Crisis Intervention" },
  { name: "F42 Rape Victim Services" },
  { name: "F50 Addictive Disorders N.E.C." },
  { name: "F52 Smoking" },
  { name: "F53 Eating Disorder, Addiction" },
  { name: "F54 Gambling" },
  { name: "F60 Counseling Support Groups" },
  { name: "F70 Mental Health Disorders" },
  { name: "F80 Mental Health Association, Multipurpose" },
  { name: "F99 Other Mental Health, Crisis Intervention N.E.C." },
  { name: "G01 Alliance/Advocacy Organizations" },
  { name: "G02 Management & Technical Assistance" },
  { name: "G03 Professional Societies, Associations" },
  { name: "G05 Research Institutes and/or Public Policy Analysis" },
  { name: "G11 Single Organization Support" },
  { name: "G12 Fund Raising and/or Fund Distribution" },
  { name: "G19 Nonmonetary Support N.E.C." },
  { name: "G20 Birth Defects" },
  { name: "G25 Down Syndrome" },
  { name: "G30 Cancer" },
  { name: "G32 Breast Cancer" },
  { name: "G40 Diseases of Specific Organs" },
  { name: "G41 Eye Diseases, Blindness and Vision Impairments" },
  { name: "G42 Ear/Throat" },
  { name: "G43 Heart and Circulatory System" },
  { name: "G44 Kidney" },
  { name: "G45 Lung" },
  { name: "G48 Brain Disorders" },
  { name: "G50 Nerve, Muscle and Bone Diseases" },
  { name: "G51 Arthritis" },
  { name: "G54 Epilepsy" },
  { name: "G60 Allergy Related Diseases" },
  { name: "G61 Asthma" },
  { name: "G70 Digestive Diseases, Disorders" },
  { name: "G80 Specifically Named Diseases" },
  { name: "G81 AIDS" },
  { name: "G83 Alzheimer's" },
  { name: "G84 Autism" },
  { name: "G90 Medical Disciplines" },
  { name: "G92 Biomedicine, Bioengineering" },
  { name: "G94 Geriatrics" },
  { name: "G96 Neurology, Neuroscience" },
  { name: "G98 Pediatrics" },
  { name: "G99 Diseases, Disorders, Medical Disciplines N.E.C." },
  { name: "G9B Surgery" },
  { name: "H01 Alliance/Advocacy Organizations" },
  { name: "H02 Management & Technical Assistance" },
  { name: "H03 Professional Societies, Associations" },
  { name: "H05 Research Institutes and/or Public Policy Analysis" },
  { name: "H11 Single Organization Support" },
  { name: "H12 Fund Raising and/or Fund Distribution" },
  { name: "H19 Nonmonetary Support N.E.C." },
  { name: "H20 Birth Defects, Genetic Diseases Research" },
  { name: "H25 Down Syndrome Research" },
  { name: "H30 Cancer Research" },
  { name: "H32 Breast Cancer Research" },
  { name: "H40 Specific Organ Research" },
  { name: "H41 Eye" },
  { name: "H42 Ear and Throat" },
  { name: "H43 Heart and Circulatory" },
  { name: "H44 Kidney" },
  { name: "H45 Lung" },
  { name: "H48 Brain Disorders" },
  { name: "H50 Nerve, Muscle, Bone Research" },
  { name: "H51 Arthritis" },
  { name: "H54 Epilepsy Research" },
  { name: "H60 Allergy Related Disease Research" },
  { name: "H61 Asthma" },
  { name: "H70 Digestive Diseases/Disorders Research" },
  { name: "H80 Specifically Named Diseases Research" },
  { name: "H81 AIDS" },
  { name: "H83 Alzheimer's" },
  { name: "H84 Autism" },
  { name: "H90 Medical Specialty Research" },
  { name: "H92 Biomedicine, Bioengineering" },
  { name: "H94 Geriatrics" },
  { name: "H96 Neurology, Neuroscience" },
  { name: "H98 Pediatrics Research" },
  { name: "H99 Other Medical Research N.E.C." },
  { name: "H9B Surgery" },
  { name: "I01 Alliance/Advocacy Organizations" },
  { name: "I02 Management & Technical Assistance" },
  { name: "I03 Professional Societies, Associations" },
  { name: "I05 Research Institutes and/or Public Policy Analysis" },
  { name: "I11 Single Organization Support" },
  { name: "I12 Fund Raising and/or Fund Distribution" },
  { name: "I19 Nonmonetary Support N.E.C." },
  { name: "I20 Crime Prevention N.E.C." },
  { name: "I21 Delinquency Prevention" },
  { name: "I23 Drunk Driving Related" },
  { name: "I30 Correctional Facilities N.E.C." },
  { name: "I31 Transitional Care, Half-Way House for Offenders/Ex-Offenders" },
  { name: "I40 Rehabilitation Services for Offenders" },
  { name: "I43 Services to Prisoners/Families" },
  { name: "I44 Prison Alternatives" },
  {
    name:
      "I50 Administration of Justice, Courts (Court Administration, Court Reform, Alternatives to Litigation and Sentencing)"
  },
  { name: "I51 Dispute Resolution/Mediation Services" },
  { name: "I60 Law Enforcement Agencies (Police Departments)" },
  {
    name:
      "I70 Protection Against and Prevention of Neglect, Abuse, Exploitation"
  },
  { name: "I71 Spouse Abuse, Prevention of" },
  { name: "I72 Child Abuse, Prevention of" },
  { name: "I73 Sexual Abuse, Prevention of" },
  { name: "I80 Legal Services" },
  { name: "I83 Public Interest Law/Litigation" },
  { name: "I99 Crime, Legal Related N.E.C." },
  { name: "J01 Alliance/Advocacy Organizations" },
  { name: "J02 Management & Technical Assistance" },
  { name: "J03 Professional Societies, Associations" },
  { name: "J05 Research Institutes and/or Public Policy Analysis" },
  { name: "J11 Single Organization Support" },
  { name: "J12 Fund Raising and/or Fund Distribution" },
  { name: "J19 Nonmonetary Support N.E.C." },
  { name: "J20 Employment Procurement Assistance and Job Training" },
  { name: "J21 Vocational Counseling / Guidance / Testing" },
  { name: "J22 Employment Training" },
  {
    name:
      "J30 Vocational Rehabilitation (includes Job Training and Employment for Disabled and Elderly)"
  },
  { name: "J32 Goodwill Industries" },
  {
    name: "J33 Sheltered Remunerative Employment, Work Activity Center N.E.C."
  },
  { name: "J40 Labor Unions/Organizations" },
  { name: "J99 Employment, Job Related N.E.C." },
  { name: "K01 Alliance/Advocacy Organizations" },
  { name: "K02 Management & Technical Assistance" },
  { name: "K03 Professional Societies, Associations" },
  { name: "K05 Research Institutes and/or Public Policy Analysis" },
  { name: "K11 Single Organization Support" },
  { name: "K12 Fund Raising and/or Fund Distribution" },
  { name: "K19 Nonmonetary Support N.E.C." },
  { name: "K20 Agricultural Programs" },
  { name: "K25 Farmland Preservation" },
  { name: "K26 Livestock Breeding, Development, Management" },
  { name: "K28 Farm Bureau" },
  { name: "K30 Food Service, Free Food Distribution Programs" },
  { name: "K31 Food Banks, Food Pantries" },
  { name: "K34 Congregate Meals" },
  { name: "K35 Organization-Sponsored Eatery or Agency" },
  { name: "K36 Meals on Wheels" },
  { name: "K40 Nutrition Programs" },
  { name: "K50 Home Economics" },
  { name: "K99 Other Food, Agriculture, and Nutrition N.E.C." },
  { name: "L01 Alliance/Advocacy Organizations" },
  { name: "L02 Management & Technical Assistance" },
  { name: "L03 Professional Societies, Associations" },
  { name: "L05 Research Institutes and/or Public Policy Analysis" },
  { name: "L11 Single Organization Support" },
  { name: "L12 Fund Raising and/or Fund Distribution" },
  { name: "L19 Nonmonetary Support N.E.C." },
  { name: "L20 Housing Development, Construction, Management" },
  { name: "L21 Public Housing" },
  { name: "L22 Senior Citizens' Housing/Retirement Communities" },
  { name: "L24 Independent Housing for People with Disabilities" },
  { name: "L25 Housing Rehabilitation" },
  { name: "L30 Housing Search Assistance" },
  { name: "L40 Low-Cost Temporary Housing (includes Youth Hostels)" },
  { name: "L41 Temporary Shelter For the Homeless" },
  { name: "L50 Housing Owners, Renters Organizations" },
  { name: "L80 Other Housing Support Services" },
  { name: "L81 Home Improvement/Repairs" },
  { name: "L82 Housing Expense Reduction Support, Rent Assistance" },
  { name: "L99 Other Housing, Shelter N.E.C." },
  { name: "M01 Alliance/Advocacy Organizations" },
  { name: "M02 Management & Technical Assistance" },
  { name: "M03 Professional Societies, Associations" },
  { name: "M05 Research Institutes and/or Public Policy Analysis" },
  { name: "M11 Single Organization Support" },
  { name: "M12 Fund Raising and/or Fund Distribution" },
  { name: "M19 Nonmonetary Support N.E.C." },
  { name: "M20 Disaster Preparedness and Relief Services" },
  { name: "M23 Search and Rescue Services" },
  { name: "M24 Fire Prevention / Protection / Control" },
  { name: "M40 Safety Education" },
  { name: "M41 First Aid Training" },
  { name: "M42 Automotive Safety" },
  { name: "M60 Public Safety Benevolent Associations" },
  { name: "M99 Other Public Safety, Disaster Preparedness, and Relief N.E.C." },
  { name: "N01 Alliance/Advocacy Organizations" },
  { name: "N02 Management & Technical Assistance" },
  { name: "N03 Professional Societies, Associations" },
  { name: "N05 Research Institutes and/or Public Policy Analysis" },
  { name: "N11 Single Organization Support" },
  { name: "N12 Fund Raising and/or Fund Distribution" },
  { name: "N19 Nonmonetary Support N.E.C." },
  { name: "N20 Recreational and Sporting Camps (Day, Overnight, etc.)" },
  { name: "N30 Physical Fitness/Community Recreational Facilities" },
  { name: "N31 Community Recreational Centers" },
  { name: "N32 Parks and Playgrounds" },
  { name: "N40 Sports Training Facilities" },
  { name: "N50 Recreational, Pleasure, or Social Club" },
  { name: "N52 County / Street / Civic / Multi-Arts Fairs and Festivals" },
  { name: "N60 Amateur Sports Clubs, Leagues, N.E.C." },
  { name: "N61 Fishing and Hunting Clubs" },
  { name: "N62 Basketball" },
  { name: "N63 Baseball, Softball (includes Little Leagues)" },
  { name: "N64 Soccer Clubs/Leagues" },
  { name: "N65 Football Clubs/Leagues" },
  { name: "N66 Tennis and Racquet Sports Clubs/Leagues" },
  { name: "N67 Swimming, Water Recreation" },
  { name: "N68 Winter Sports (Snow and Ice)" },
  { name: "N69 Equestrian, Riding" },
  { name: "N6A Golf (Country Clubs, use N50)" },
  { name: "N70 Amateur Sports Competitions" },
  { name: "N71 Olympics Committees and Related International Competitions" },
  { name: "N72 Special Olympics" },
  { name: "N80 Professional Athletic Leagues" },
  { name: "N99 Other Recreation, Sports, or Leisure Activities N.E.C." },
  { name: "O01 Alliance/Advocacy Organizations" },
  { name: "O02 Management & Technical Assistance" },
  { name: "O03 Professional Societies, Associations" },
  { name: "O05 Research Institutes and/or Public Policy Analysis" },
  { name: "O11 Single Organization Support" },
  { name: "O12 Fund Raising and/or Fund Distribution" },
  { name: "O19 Nonmonetary Support N.E.C." },
  {
    name: "O20 Youth Centers, Clubs, (includes Boys/Girls Clubs)- Multipurpose"
  },
  { name: "O21 Boys Clubs" },
  { name: "O22 Girls Clubs" },
  { name: "O23 Boys and Girls Clubs (Combined)" },
  { name: "O30 Adult, Child Matching Programs" },
  { name: "O31 Big Brothers, Big Sisters" },
  { name: "O40 Scouting" },
  { name: "O41 Boy Scouts" },
  { name: "O42 Girl Scouts" },
  { name: "O43 Camp Fire" },
  { name: "O50 Youth Development Programs" },
  { name: "O51 Youth Community Service Clubs" },
  { name: "O52 Agricultural, Youth Development" },
  { name: "O53 Business, Youth Development" },
  { name: "O54 Citizenship Programs, Youth Development" },
  { name: "O55 Religious Leadership, Youth Development" },
  { name: "O99 Other Youth Development N.E.C." },
  { name: "P01 Alliance/Advocacy Organizations" },
  { name: "P02 Management & Technical Assistance" },
  { name: "P03 Professional Societies, Associations" },
  { name: "P05 Research Institutes and/or Public Policy Analysis" },
  { name: "P11 Single Organization Support" },
  { name: "P12 Fund Raising and/or Fund Distribution" },
  { name: "P19 Nonmonetary Support N.E.C." },
  { name: "P20 Human Service Organizations" },
  { name: "P21 American Red Cross" },
  { name: "P22 Urban League" },
  { name: "P24 Salvation Army" },
  { name: "P26 Volunteers of America" },
  { name: "P27 YMCA, YWCA, YWHA, YMHA" },
  { name: "P28 Neighborhood Center, Settlement House" },
  { name: "P29 Thrift Shops" },
  { name: "P30 Children's and Youth Services" },
  { name: "P31 Adoption" },
  { name: "P32 Foster Care" },
  { name: "P33 Child Day Care" },
  { name: "P40 Family Services" },
  { name: "P42 Single Parent Agencies/Services" },
  { name: "P43 Family Violence Shelters and Services" },
  { name: "P44 Homemaker, Home Health Aide" },
  { name: "P45 Family Services (Adolescent Parents)" },
  { name: "P46 Family Counseling, Marriage Counseling" },
  { name: "P47 Pregnancy Centers" },
  { name: "P50 Personal Social Services" },
  { name: "P51 Financial Counseling, Money Management" },
  { name: "P52 Transportation (Free or Subsidized)" },
  { name: "P58 Gift Distribution" },
  { name: "P60 Emergency Assistance (Food, Clothing, Cash)" },
  { name: "P61 Travelers' Aid" },
  { name: "P62 Victims' Services" },
  { name: "P70 Residential, Custodial Care (Group Home)" },
  { name: "P71 Adult Day Care" },
  { name: "P72 Half-Way House (Short-Term Residential Care)" },
  { name: "P73 Group Home (Long Term" },
  { name: "P74 Hospice" },
  { name: "P75 Senior Continuing Care Communities" },
  { name: "P76 Homes for Children & Adolescents" },
  { name: "P80 Services to Promote the Independence of Specific Populations" },
  { name: "P81 Senior Centers/Services" },
  { name: "P82 Developmentally Disabled Services/Centers" },
  { name: "P83 Women's Centers" },
  { name: "P84 Ethnic/Immigrant Services" },
  { name: "P85 Homeless Services/Centers" },
  { name: "P86 Blind/Visually Impaired Centers, Services" },
  { name: "P87 Deaf/Hearing Impaired Centers, Services" },
  { name: "P88 LGBT Centers" },
  { name: "P99 Human Services - Multipurpose and Other N.E.C." },
  { name: "Q01 Alliance/Advocacy Organizations" },
  { name: "Q02 Management & Technical Assistance" },
  { name: "Q03 Professional Societies, Associations" },
  { name: "Q05 Research Institutes and/or Public Policy Analysis" },
  { name: "Q11 Single Organization Support" },
  { name: "Q12 Fund Raising and/or Fund Distribution" },
  { name: "Q19 Nonmonetary Support N.E.C." },
  { name: "Q20 Promotion of International Understanding" },
  { name: "Q21 International Cultural Exchange" },
  { name: "Q22 International Student Exchange and Aid" },
  { name: "Q23 International Exchanges" },
  { name: "Q30 International Development, Relief Services" },
  { name: "Q31 International Agricultural Development" },
  { name: "Q32 International Economic Development" },
  { name: "Q33 International Relief" },
  { name: "Q34 International Educational Development" },
  { name: "Q35 International Democracy & Civil Society Development" },
  { name: "Q36 International Science & Technology Development" },
  { name: "Q38 International Environment, Population & Sustainability" },
  { name: "Q39 International Health Development" },
  { name: "Q40 International Peace and Security" },
  { name: "Q41 Arms Control, Peace Organizations" },
  { name: "Q42 United Nations Association" },
  {
    name:
      "Q43 Domestic National Security (includes Military and Defense Issues)"
  },
  { name: "Q50 International Affairs, Foreign Policy, & Globalization" },
  { name: "Q51 International Economic & Trade Policy" },
  { name: "Q70 International Human Rights" },
  { name: "Q71 International Migration, Refugee Issues" },
  { name: "Q99 International, Foreign Affairs, and National Security N.E.C." },
  { name: "R01 Alliance/Advocacy Organizations" },
  { name: "R02 Management & Technical Assistance" },
  { name: "R03 Professional Societies, Associations" },
  { name: "R05 Research Institutes and/or Public Policy Analysis" },
  { name: "R11 Single Organization Support" },
  { name: "R12 Fund Raising and/or Fund Distribution" },
  { name: "R19 Nonmonetary Support N.E.C." },
  { name: "R20 Civil Rights, Advocacy for Specific Groups" },
  { name: "R21 Immigrants' Rights" },
  { name: "R22 Minority Rights" },
  { name: "R23 Disabled Persons' Rights" },
  { name: "R24 Women's Rights" },
  { name: "R25 Seniors' Rights" },
  { name: "R26 Lesbian/Gay Rights" },
  { name: "R27 Patients' Rights" },
  { name: "R28 Children's Rights" },
  { name: "R29 Employee & Workers' Rights" },
  { name: "R30 Intergroup/Race Relations" },
  { name: "R40 Voter Education/Registration" },
  { name: "R60 Civil Liberties Advocacy" },
  { name: "R61 Reproductive Rights" },
  { name: "R62 Right to Life" },
  { name: "R63 Censorship, Freedom of Speech and Press Issues" },
  { name: "R65 Freedom of Religion Issues" },
  { name: "R67 Right to Die, Euthanasia Issues" },
  { name: "R99 Civil Rights, Social Action, and Advocacy N.E.C." },
  { name: "S01 Alliance/Advocacy Organizations" },
  { name: "S02 Management & Technical Assistance" },
  { name: "S03 Professional Societies, Associations" },
  { name: "S05 Research Institutes and/or Public Policy Analysis" },
  { name: "S11 Single Organization Support" },
  { name: "S12 Fund Raising and/or Fund Distribution" },
  { name: "S19 Nonmonetary Support N.E.C." },
  { name: "S20 Community, Neighborhood Development, Improvement" },
  { name: "S21 Community Coalitions" },
  { name: "S22 Neighborhood/Block Associations" },
  { name: "S30 Economic Development" },
  { name: "S31 Urban, Community" },
  { name: "S32 Rural" },
  { name: "S40 Business and Industry" },
  { name: "S41 Promotion of Business (Chambers of Commerce)" },
  { name: "S43 Management Services for Small Business/Entrepreneurs" },
  { name: "S46 Boards of Trade" },
  { name: "S47 Real Estate Organizations" },
  { name: "S50 Nonprofit Management" },
  { name: "S80 Community Service Clubs (Kiwanis, Lions, Jaycees, etc.)" },
  { name: "S81 Women's Service Clubs" },
  { name: "S82 Men's Service Clubs" },
  { name: "S99 Community Improvement, Capacity Building N.E.C." },
  { name: "T01 Alliance/Advocacy Organizations" },
  { name: "T02 Management & Technical Assistance" },
  { name: "T03 Professional Societies, Associations" },
  { name: "T05 Research Institutes and/or Public Policy Analysis" },
  { name: "T11 Single Organization Support" },
  { name: "T12 Fund Raising and/or Fund Distribution" },
  { name: "T19 Nonmonetary Support N.E.C." },
  { name: "T20 Private Grantmaking Foundations" },
  { name: "T21 Corporate Foundations" },
  { name: "T22 Private Independent Foundations" },
  { name: "T23 Private operating foundation" },
  { name: "T30 Public Foundations" },
  { name: "T31 Community Foundations" },
  { name: "T40 Voluntarism Promotion" },
  { name: "T50 Philanthropy / Charity / Voluntarism Promotion (General)" },
  {
    name:
      "T70 Fund Raising Organizations That Cross Categories includes Community Funds/Trusts and Federated Giving Programs) e.g. United Way"
  },
  { name: "T90 Named Trusts/Foundations N.E.C." },
  {
    name:
      "T99 Other Philanthropy, Voluntarism, and Grantmaking Foundations N.E.C."
  },
  { name: "U01 Alliance/Advocacy Organizations" },
  { name: "U02 Management & Technical Assistance" },
  { name: "U03 Professional Societies, Associations" },
  { name: "U05 Research Institutes and/or Public Policy Analysis" },
  { name: "U11 Single Organization Support" },
  { name: "U12 Fund Raising and/or Fund Distribution" },
  { name: "U19 Nonmonetary Support N.E.C." },
  {
    name:
      "U20 Science, General (includes Interdisciplinary Scientific Activities)"
  },
  { name: "U21 Marine Science and Oceanography" },
  { name: "U30 Physical Sciences/Earth Sciences Research and Promotion" },
  { name: "U31 Astronomy (includes Observatories)" },
  { name: "U33 Chemistry, Chemical Engineering (includes Polymer Science)" },
  { name: "U34 Mathematics" },
  { name: "U36 Geology" },
  { name: "U40 Engineering and Technology Research, Services" },
  { name: "U41 Computer Science" },
  { name: "U42 Engineering" },
  { name: "U50 Biological & Life Sciences" },
  { name: "U99 Science and Technology Research Institutes, Services N.E.C." },
  { name: "V01 Alliance/Advocacy Organizations" },
  { name: "V02 Management & Technical Assistance" },
  { name: "V03 Professional Societies, Associations" },
  { name: "V05 Research Institutes and/or Public Policy Analysis" },
  { name: "V11 Single Organization Support" },
  { name: "V12 Fund Raising and/or Fund Distribution" },
  { name: "V19 Nonmonetary Support N.E.C." },
  { name: "V20 Social Science Research Institutes, Services" },
  { name: "V21 Anthropology, Sociology" },
  { name: "V22 Economics (as a Social Science)" },
  { name: "V23 Behavioral Science" },
  { name: "V24 Political Science" },
  { name: "V25 Population Studies Demographics (includes Geography)" },
  { name: "V26 Law, International Law, and Jurisprudence" },
  { name: "V30 Interdisciplinary Research" },
  { name: "V31 Black Studies" },
  { name: "V32 Women's Studies" },
  { name: "V33 Ethnic Studies" },
  { name: "V34 Urban Studies" },
  { name: "V35 International Studies" },
  { name: "V36 Gerontology" },
  { name: "V37 Labor Studies" },
  { name: "V99 Social Science Research Institutes, Services N.E.C." },
  { name: "W01 Alliance/Advocacy Organizations" },
  { name: "W02 Management & Technical Assistance" },
  { name: "W03 Professional Societies, Associations" },
  { name: "W05 Research Institutes and/or Public Policy Analysis" },
  { name: "W11 Single Organization Support" },
  { name: "W12 Fund Raising and/or Fund Distribution" },
  { name: "W19 Nonmonetary Support N.E.C." },
  { name: "W20 Government and Public Administration" },
  { name: "W22 Public Finance, Taxation, Monetary Policy" },
  { name: "W24 Citizen Participation" },
  { name: "W30 Military/Veterans' Organizations" },
  { name: "W40 Public Transportation Systems and Services" },
  { name: "W50 Telephone, Telegraph and Telecommunication Services" },
  { name: "W60 Financial Institutions/Services (Non-Government Related)" },
  { name: "W61 Credit Unions" },
  { name: "W70 Leadership Development" },
  { name: "W80 Public Utilities" },
  { name: "W90 Consumer Protection and Safety" },
  { name: "W99 Public, Society Benefit - Multipurpose and Other N.E.C." },
  { name: "X01 Alliance/Advocacy Organizations" },
  { name: "X02 Management & Technical Assistance" },
  { name: "X03 Professional Societies, Associations" },
  { name: "X05 Research Institutes and/or Public Policy Analysis" },
  { name: "X11 Single Organization Support" },
  { name: "X12 Fund Raising and/or Fund Distribution" },
  { name: "X19 Nonmonetary Support N.E.C." },
  { name: "X20 Christian" },
  { name: "X21 Protestant" },
  { name: "X22 Roman Catholic" },
  { name: "X30 Jewish" },
  { name: "X40 Islamic" },
  { name: "X50 Buddhist" },
  { name: "X70 Hindu" },
  { name: "X80 Religious Media, Communications Organizations" },
  { name: "X81 Religious Film & Video" },
  { name: "X82 Religious Television" },
  { name: "X83 Religious Printing, Publishing" },
  { name: "X84 Religious Radio" },
  { name: "X90 Interfaith Issues" },
  { name: "X99 Religion Related, Spiritual Development N.E.C." },
  { name: "Y01 Alliance/Advocacy Organizations" },
  { name: "Y02 Management & Technical Assistance" },
  { name: "Y03 Professional Societies, Associations" },
  { name: "Y05 Research Institutes and/or Public Policy Analysis" },
  { name: "Y11 Single Organization Support" },
  { name: "Y12 Fund Raising and/or Fund Distribution" },
  { name: "Y19 Nonmonetary Support N.E.C." },
  { name: "Y20 Insurance Providers/Services (other than Health)" },
  {
    name:
      "Y22 Benevolent Life Insurance Association, Mutual Irrigations and Telephone Companies, and Like Organizations"
  },
  { name: "Y23 Mutual Insurance Company or Association" },
  { name: "Y24 Supplemental Unemployment Compensation" },
  {
    name: "Y25 State-Sponsored Worker's Compensation Reinsurance Organizations"
  },
  { name: "Y30 Pension and Retirement Funds" },
  { name: "Y33 Teachers' Retirement Fund Association" },
  { name: "Y34 Employee Funded Pension Trust" },
  { name: "Y35 Multi-Employer Pension Plans" },
  { name: "Y40 Fraternal Societies" },
  { name: "Y41 Fraternal Beneficiary Societies" },
  { name: "Y42 Domestic Fraternal Societies" },
  { name: "Y43 Voluntary Employees Beneficiary Associations (Non-Government)" },
  { name: "Y44 Voluntary Employees Beneficiary Associations (Government)" },
  { name: "Y50 Cemeteries and Burial Services" },
  { name: "Y99 Mutual/Membership Benefit Organizations, Other N.E.C." },
  { name: "Z99 Unknown" }
];
